import { render, staticRenderFns } from "./Isso.vue?vue&type=template&id=510e910f&scoped=true&"
import script from "./Isso.vue?vue&type=script&lang=js&"
export * from "./Isso.vue?vue&type=script&lang=js&"
import style0 from "./Isso.vue?vue&type=style&index=0&id=510e910f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510e910f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('510e910f')) {
      api.createRecord('510e910f', component.options)
    } else {
      api.reload('510e910f', component.options)
    }
    module.hot.accept("./Isso.vue?vue&type=template&id=510e910f&scoped=true&", function () {
      api.rerender('510e910f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Isso/Isso.vue"
export default component.exports